<template>
  <CommonIconLabel icon="Mail" :size="size">
    <p class="label-email">
      <a :href="`mailto:${email}`">{{ email }}</a>
      <ArrowUpRight :size="16" />
    </p>
  </CommonIconLabel>
</template>

<script setup lang="ts">
import CommonIconLabel from '@/components/common/CommonIconLabel.vue'
import { ArrowUpRight } from 'lucide-vue-next'

withDefaults(
  defineProps<{
    email: string
    size: 'small' | 'medium'
  }>(),
  {
    size: 'small'
  }
)
</script>

<style scoped>
.label-email {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.label-email > a {
  text-decoration: underline;
}
</style>
